<template>
  <BaseCard :title="title" :max-width="maxWidth">
    <slot></slot>
    <div v-if="files && files.length" class="d-flex flex-wrap gap-8">
      <template v-for="(i, key) in files">
        <div
          v-if="
            (files.length > numberImagesShow ? key > files.length - numberImagesShow - 1 : true) &&
            (typeof i === 'string' ? i.length : true)
          "
          :key="key + '_' + keyChange"
          class="width170"
        >
          <ImageFullModal v-if="onCheckFileType(i) === 'image'" :editing="editing" :src="i">
            <template slot="button">
              <ImageEdit v-if="editing" :src="i" :id="key" :on-edit="editImage" get-upload />
            </template>
          </ImageFullModal>
          <ContractPdfModal v-else :url="i" />
          <div class="d-flex justify-space-between">
            <BaseTooltip
              v-if="editing"
              :tooltip="localStorage.translations.pages.common.buttons.udalit"
            >
              <BaseButton
                customClass="red"
                round
                icon_only
                default_icon="button-delete"
                size="30"
                padding="7"
                @click="askDeleteImage(key)"
                class="mx-n3"
              />
              <v-dialog v-model="dialog" width="400">
                <v-card class="pa-4">
                  <v-btn icon absolute right top class="mt-n2 mr-n2" @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <h3 class="text-center">
                    {{ localStorage.translations.pages.common.buttons.udalit }} ?
                  </h3>
                  <div class="d-flex justify-space-around mt-8">
                    <v-hover v-slot="{ hover }">
                      <v-btn
                        fab
                        :outlined="!hover"
                        :depressed="!hover"
                        dark
                        color="#26bc2c"
                        @click="dialog = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-hover>
                    <v-hover v-slot="{ hover }">
                      <v-btn
                        fab
                        :depressed="!hover"
                        :outlined="!hover"
                        :dark="hover"
                        color="red"
                        @click="onDeleteImage(id)"
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </v-hover>
                  </div>
                </v-card>
              </v-dialog>
            </BaseTooltip>
            <div v-else />
            <BaseTooltip
              v-if="editing && onCheckFileType(i) === 'image'"
              :tooltip="localStorage.translations.pages.common.buttons.redaktirovat"
            >
              <BaseButton
                round
                icon_only
                default_icon="button-edit"
                size="30"
                padding="7"
                @click="onEditImage(key)"
                class="mx-n3"
              />
            </BaseTooltip>
          </div>
          <ImageEdit
            :src="i"
            :id="key"
            :on-edit="editImage"
            get-upload
            :ref="'edit_image_' + key"
            invisible
          />
        </div>
      </template>
    </div>
    <template
      v-if="
        (fileEditAccess ? fileEditAccess : true) &&
        files &&
        (maxFiles ? Number(maxFiles) > this.files.length : true)
      "
    >
      <input
        style="display: none"
        type="file"
        id="file"
        ref="file"
        :accept="fileAcceptFormated"
        v-on:change="onHandleFileUpload"
      />
      <BaseButton
        v-if="editing"
        :text="
          localStorage.translations.pages['setting-personal_area'].buttons[
            maxFiles || Number(maxFilesShow) > 1
              ? 'zagruzit'
              : files && files.length
              ? 'obnovit'
              : 'zagruzit'
          ]
        "
        default_icon="button-upload"
        @click="$refs.file.click()"
      >
        <IconFileFormat
          slot="append"
          :jpg="fileAcceptText.toLowerCase().includes('jpg')"
          :png="fileAcceptText.toLowerCase().includes('png')"
          :pdf="fileAcceptText.toLowerCase().includes('pdf')"
        />
      </BaseButton>
    </template>
    <div v-if="onSave" class="text-end">
      <slot name="on_save">
        <BaseButton
          :text="localStorage.translations.pages.common.buttons.sohranit"
          default_icon="button-save"
          @click="onClickSave"
        />
      </slot>
    </div>
  </BaseCard>
</template>

<script>
import ImageFullModal from 'components/ImageFullModal'
import ContractPdfModal from 'components/personalArea/ContractPdfModal'
import IconFileFormat from 'components/icons/IconFileFormat'
import ImageEdit from 'components/ImageEdit'

export default {
  name: 'PersonalAreaTemplate',
  components: {
    ImageEdit,
    IconFileFormat,
    ImageFullModal,
    ContractPdfModal,
  },
  props: {
    blockMarginTop: {
      type: [String, Number],
      default: '25px',
    },
    maxWidth: [String, Number],
    click: Function,
    tableHead: [Array, Object],
    files: [Array, String],
    maxFilesShow: { type: [String, Number], default: 1 },
    maxFiles: [String, Number],
    deleteFiles: [Array],
    editing: Boolean,
    fileAccept: {
      type: [Array],
      default: () => ['jpg', 'jpeg', 'png', 'pdf'],
    },
    fileEditAccess: [Function, Boolean],
    onSave: {},
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return { block: false, file: null, keyChange: 0, id: 0, dialog: false }
  },
  computed: {
    numberImagesShow() {
      return typeof this.maxFilesShow === 'string' ? Number(this.maxFilesShow) : this.maxFilesShow
    },
    fileAcceptFormated() {
      let result = null
      for (let accept of this.fileAccept) {
        if (result === null) {
          result = '.' + accept
        } else {
          result = result + ', .' + accept
        }
      }
      return result
    },
    fileAcceptText() {
      const firstLetterCaps = (string) => string[0].toUpperCase() + string.substring(1)
      let result = null
      for (let accept of this.fileAccept) {
        if (result === null) {
          if (accept === 'pdf') {
            result = accept.toUpperCase()
          } else {
            result = firstLetterCaps(accept)
          }
        } else {
          if (accept === 'pdf') {
            result = result + ', ' + accept.toUpperCase()
          } else {
            result = result + ', ' + firstLetterCaps(accept)
          }
        }
      }
      return result
    },
  },
  methods: {
    onCheckFileType(value) {
      let result
      if (typeof value === 'string') {
        result = value.split('.')[1] === 'pdf' ? 'application' : 'image'
      } else {
        if (value && value.type) result = value.type.split('/')[0]
      }
      //console.log('result', result)
      return result
    },
    askDeleteImage(index) {
      this.id = index
      this.dialog = true
    },
    onDeleteImage(index) {
      console.log('image', index)
      if (this.deleteFiles && typeof this.files[index] === 'string') {
        this.deleteFiles.push(this.files[index])
      }
      this.files.splice(index, 1)
      this.dialog = false
    },
    onHandleFileUpload(e) {
      const filesUpload = e.target.files
      const fileIndex = this.files.findIndex((i) => typeof i !== 'string')
      console.log('fileIndex', fileIndex)
      for (let file of filesUpload) {
        if (this.maxFiles || Number(this.maxFilesShow) > 1) {
          if (this.maxFiles) {
            if (Number(this.maxFiles) > this.files.length) {
              this.files.push(file)
            }
          } else {
            if (Number(this.maxFilesShow) > this.files.length) {
              this.files.push(file)
            }
          }
        } else {
          if (fileIndex > -1) {
            this.files[fileIndex] = file
            this.keyChange += 1
          } else {
            this.files.push(file)
          }
        }
      }
    },
    editImage(image, id) {
      this.files.splice(id, 1, image)
      this.keyChange += 1
    },
    onClickSave() {
      if (this.onSave) this.onSave()
    },
    onEditImage(key) {
      console.log(key)
      if (this.$refs['edit_image_' + key]) {
        this.$refs['edit_image_' + key][0].openCropDialog()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.width170 {
  width: 170px;
}
:deep() .base-tooltip {
  z-index: 2;
}
</style>